export default {
	"baiduPointMap": {
		"handleTips": "请拖动一下坐标地址"
	}
}


// WEBPACK FOOTER //
// ./src/lang/zh-CN/components/map/map.js